import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ZtSliderConfig } from './zt-slider.model';

@Component({
    selector: 'zt-slider',
    templateUrl: 'zt-slider.component.html',
    styleUrls: ['zt-slider.component.scss'],
})
export class ZtSliderComponent implements OnInit, OnDestroy {
    @Input() value: number = 0.0;
    @Input() max: number = 1.0;
    @Input() min: number = 0.0;
    @Input() step: number = 0.1;
    @Input() disabled: boolean = false;
    @Input() config?: ZtSliderConfig;
    @Input() control!: FormControl<number>;

    @Output() onChange = new EventEmitter<number>();

    private valueChangesSubscription: Subscription = new Subscription();

    ngOnInit() {
        if (this.control) {
            this.value = this.control?.value;
        }
        this.valueChangesSubscription = this.control?.valueChanges.subscribe(
            (newValue: any) => {
                this.value = newValue;
            }
        );
    }

    onChangeListener(newValue: number) {
        this.onChange.emit(newValue);
    }

    ngOnDestroy(): void {
        this.valueChangesSubscription?.unsubscribe();
    }
}
